export const MOCK_LATENCY_MS = 200;
